{
  "columnResizer": "Instrument redimensionare coloane",
  "loading": "Se încarcă...",
  "loadingMore": "Se încarcă mai multe...",
  "resizeColumn": "Redimensionați coloana",
  "sortAscending": "Sortați crescător",
  "sortDescending": "Sortați descrescător"
}
